import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PromotionSend from '../../../PromotionSend/index';

export default () => (
  <Switch>
    <Route exact path="/newPromotion" component={PromotionSend} />
  </Switch>
);
